import { ApiResponse } from "api/api.d";
import { api } from "api/api";
import {
  CheckAnotherBankCardAccount,
  CheckerConfirmInterbankTransferResponse,
  CheckerReviewInterbankTransferResponse,
  FindTransactionDetailResponse,
  GetBatchOrderDetailsResponse,
  GetBulkTransferDetailApprovalResponse,
  GetListDomesticBank,
  GetTransactionDetailResponse,
  GetTransactionListResponse,
  InitActionRequest,
  MakerConfirmInterbankTransferResponse,
  MakerInitBulkTransferRequest,
  MakerInitInterbankTransferResponse,
} from "dto/transfer/response/TransferInfo";
import {
  CheckerConfirmBulkTransferRequest,
  CheckerConfirmInterbankTransferRequest,
  CheckerReviewInterbankTransferRequest,
  ConfirmActionRequest,
  FindTransactionDetailRequest,
  GetBatchOrderDetailsRequest,
  GetBulkTransferDetailApprovalRequest,
  GetTransactionDetailRequest,
  GetTransactionListRequest,
  MakerConfirmInterbankTransferRequest,
  MakerInitInterbankTransferRequest,
} from "@/dto/transfer/request/transfer-request";
import _ from "lodash";
import { RESULT_CODE } from "../constants/enum";

const BASE_URL = "/transfer-service/rest/app/request";
export const transferAPI = api.injectEndpoints({
  endpoints: (builder) => ({

    getListDomesticBank: builder.query<ApiResponse<GetListDomesticBank>, void>({
      query: () => ({
        url: BASE_URL,
        method: "POST",
        functionName: "getDomesticBank",
        categoryCode: "D_TRANSFER_EWALLET",
      }),
    }),
    checkAnotherBankCardAccount: builder.query<
      ApiResponse<CheckAnotherBankCardAccount>,
      { inputValue: string; bankCode: string }
    >({
      query: ({ inputValue, bankCode }) => ({
        url: "/transfer-service/rest/app/request",
        method: "POST",
        functionName: "checkAnotherBankCardAccount",
        data: {
          inputValue,
          currencyCode: "VND",
          isQr: 0,
          bankCode,
        },
      }),
    }),
    makerInitInterbankTransfer: builder.mutation<
      ApiResponse<MakerInitInterbankTransferResponse>,
      MakerInitInterbankTransferRequest
    >({
      query: (data) => ({
        url: "/transfer-service/rest/web/request",
        method: "POST",
        functionName: "makerInitInterbankTransfer",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
    }),
    makerConfirmInterbankTransfer: builder.mutation<
      ApiResponse<MakerConfirmInterbankTransferResponse>,
      MakerConfirmInterbankTransferRequest
    >({
      query: (data) => ({
        url: "/transfer-service/rest/web/request",
        method: "POST",
        functionName: "makerConfirmInterbankTransfer",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
      invalidatesTags(result) {
        const resultCode = _.get(result, "body.resultCode");
        if (resultCode !== RESULT_CODE.SUCCESS) {
          return [];
        }
        return [
          { type: "getNotificationSticky", id: "LIST" },
          { type: "getTransactionList", id: "LIST" },
        ];
      },
    }),
    findTransactionDetail: builder.query<
      ApiResponse<FindTransactionDetailResponse>,
      FindTransactionDetailRequest
    >({
      query: (data) => ({
        url: "/transfer-service/rest/web/request",
        method: "POST",
        functionName: "findTransactionDetail",
        data,
        categoryCode: "D_TRANSFER_EWALLET",
      }),
    }),
    checkerReviewInterbankTransfer: builder.query<
      ApiResponse<CheckerReviewInterbankTransferResponse>,
      CheckerReviewInterbankTransferRequest
    >({
      query: (data) => ({
        url: "/transfer-service/rest/web/request",
        method: "POST",
        functionName: "checkerReviewInterbankTransfer",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
    }),
    checkerConfirmInterbankTransfer: builder.mutation<
      ApiResponse<CheckerConfirmInterbankTransferResponse>,
      CheckerConfirmInterbankTransferRequest
    >({
      query: (data) => ({
        url: "/transfer-service/rest/web/request",
        method: "POST",
        functionName: "checkerConfirmInterbankTransfer",
        data,
        categoryCode: "D_TRANSFER_EWALLET",
      }),
      invalidatesTags(result) {
        const resultCode = _.get(result, "body.resultCode");
        if (resultCode !== RESULT_CODE.SUCCESS) {
          return [];
        }
        return [
          { type: "getNotificationSticky", id: "LIST" },
          { type: "getTransactionList", id: "LIST" },
        ];
      },
    }),
    getTransactionList: builder.query<
      ApiResponse<GetTransactionListResponse>,
      GetTransactionListRequest
    >({
      query: (data) => ({
        url: "/historical-service/rest/web/request",
        method: "POST",
        functionName: "getTransactionList",
        data,
        categoryCode: "D_TRANSFER_EWALLET",
      }),
      providesTags(result) {
        const resultCode = _.get(result, "body.resultCode");

        if (resultCode !== RESULT_CODE.SUCCESS) {
          return [];
        }

        return [{ type: "getTransactionList", id: "LIST" }];
      },
    }),
    getTransactionDetail: builder.query<
      GetTransactionDetailResponse,
      GetTransactionDetailRequest
    >({
      query: (data) => ({
        url: "/historical-service/rest/web/request",
        method: "POST",
        functionName: "getTransactionDetail",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
      providesTags(result, _err, arg) {
        const resultCode = _.get(result, "body.resultCode");

        if (resultCode !== RESULT_CODE.SUCCESS) {
          return [];
        }

        return [{ type: "getTransactionDetail", id: arg.transId }];
      },
    }),
    initAction: builder.mutation<any, InitActionRequest>({
      query: (data) => ({
        url: "/approval-service/rest/web/request",
        method: "POST",
        functionName: "initAction",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
    }),
    checkerInitBuyFX: builder.mutation<any, { approvalId: string; actionType: string }>({
      query: (data) => ({
        url: "/approval-service/rest/web/request",
        method: "POST",
        functionName: "checkerInitBuyFX",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
    }),
    checkerConfirmBuyFX: builder.mutation<any, { otpId: string; otp: string }>({
      query: (data) => ({
        url: "/approval-service/rest/web/request",
        method: "POST",
        functionName: "checkerConfirmBuyFX",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
      invalidatesTags(result) {
        const resultCode = _.get(result, "body.resultCode");
        if (resultCode !== RESULT_CODE.SUCCESS) {
          return [];
        }
        return [
          { type: "getNotificationSticky", id: "LIST" },
          { type: "getTransactionList", id: "LIST" },
        ];
      },
    }),
    makerInitBulkTransfer: builder.query<any, MakerInitBulkTransferRequest>({
      query: (data) => ({
        url: "/bulk-transfer-service/rest/web/request",
        method: "POST",
        functionName: "makerInitBulkTransfer",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
    }),
    confirmAction: builder.mutation<any, ConfirmActionRequest>({
      query: (data) => ({
        url: "/approval-service/rest/web/request",
        method: "POST",
        functionName: "confirmAction",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
      invalidatesTags(result) {
        const resultCode = _.get(result, "body.resultCode");
        if (resultCode !== RESULT_CODE.SUCCESS) {
          return [];
        }
        return [
          { type: "getNotificationSticky", id: "LIST" },
          { type: "getTransactionList", id: "LIST" },
        ];
      },
    }),
    checkerReviewBulkTransfer: builder.query<any, any>({
      query: (data) => ({
        url: "/bulk-transfer-service/rest/web/request",
        method: "POST",
        functionName: "checkerReviewBulkTransfer",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
    }),
    getBulkTransferDetailApproval: builder.query<
      ApiResponse<GetBulkTransferDetailApprovalResponse>,
      GetBulkTransferDetailApprovalRequest
    >({
      query: (data) => ({
        url: "/bulk-transfer-service/rest/web/request",
        method: "POST",
        functionName: "getBulkTransferDetailApproval",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
    }),
    checkerConfirmBulkTransfer: builder.mutation<
      any,
      CheckerConfirmBulkTransferRequest
    >({
      query: (data) => ({
        url: "/bulk-transfer-service/rest/web/request",
        method: "POST",
        functionName: "checkerConfirmBulkTransfer",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
    }),
    getBatchOrderDetails: builder.query<GetBatchOrderDetailsResponse,GetBatchOrderDetailsRequest>({
      query: (data) => ({
        url: "/bulk-transfer-service/rest/web/request",
        method: "POST",
        functionName: "getBatchOrderDetails",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
    }),
    checkDuplicateInterbankTransfer: builder.mutation<any, any>({
      query: (data) => ({
        url: BASE_URL,
        method: "POST",
        functionName: "CheckDuplicateInterbankTransfer",
        data,
        categoryCode: "CORP_TRANS_TRANSFER_TO_ACCOUNT",
      }),
    }),
  }),
});

export const {
  useGetListDomesticBankQuery,
  useCheckAnotherBankCardAccountQuery,
  useLazyCheckAnotherBankCardAccountQuery,
  useMakerInitInterbankTransferMutation,
  useMakerConfirmInterbankTransferMutation,
  useFindTransactionDetailQuery,
  useCheckerReviewInterbankTransferQuery,
  useCheckerConfirmInterbankTransferMutation,
  useGetTransactionListQuery,
  useInitActionMutation,
  useCheckerInitBuyFXMutation,
  useCheckerConfirmBuyFXMutation,
  useLazyCheckerReviewInterbankTransferQuery,
  useMakerInitBulkTransferQuery,
  useConfirmActionMutation,
  useLazyMakerInitBulkTransferQuery,
  useCheckerReviewBulkTransferQuery,
  useGetBulkTransferDetailApprovalQuery,
  useCheckerConfirmBulkTransferMutation,
  useGetTransactionDetailQuery,
  useGetBatchOrderDetailsQuery,
  useCheckDuplicateInterbankTransferMutation
} = transferAPI;
